import { render, staticRenderFns } from "./NiezrownanaZwyciezczyni.vue?vue&type=template&id=6626fa2a&scoped=true&"
import script from "./NiezrownanaZwyciezczyni.vue?vue&type=script&lang=js&"
export * from "./NiezrownanaZwyciezczyni.vue?vue&type=script&lang=js&"
import style0 from "./NiezrownanaZwyciezczyni.vue?vue&type=style&index=0&id=6626fa2a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6626fa2a",
  null
  
)

export default component.exports